import React, { useEffect, useState } from "react";
import { createScholarshipMapping, getAllCollegePagination, getAllCountry, getScholarships } from "../../Services/MasterService";
import { toast } from "react-toastify";
import Select from 'react-select';
import { debounce } from "lodash";

const AddScholarshipMapping = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({});
    const [loader, setLoader] = useState(false);
    const [entity, setEntity] = useState([]);
    const [scholarship, setSholarship] = useState([]);
    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader("submit");
        let { ok } = await createScholarshipMapping(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getScholarshipCall = async () => {
        let { ok, data } = await getScholarships({});
        if (ok) {
            setSholarship(data?.records);
        }
    };

    const getEntity = async (search) => {
        setEntity([]);
        if (reqData?.entity) {
            setLoader("entity");
            if (reqData?.entity == "college" || reqData?.entity == "department") {
                let { ok, data } = await getAllCollegePagination({ page_number: 0, page_size: 20, search: search || "" });
                if (ok) {
                    setEntity(data?.records);
                }
            };
            if (reqData?.entity == "target_country" || reqData?.entity == "source_country") {
                let { ok, data } = await getAllCountry({ page_number: 0, page_size: 20, search: search || "" });
                if (ok) {
                    setEntity(data?.records);
                }
            }
            setLoader(false);
        };
    };

    const debouncedFetchData = debounce((inputValue) => {
        getEntity(inputValue);
    }, 500);

    const handleInputChange = (inputValue) => {
        debouncedFetchData(inputValue);
    };

    useEffect(() => {
        getScholarshipCall();
        if (data?.data) {
            setReqData(data?.data)
        }
    }, []);

    useEffect(() => {
        getEntity();
    }, [reqData?.entity]);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Scholarship Mapping" : "Edit Scholarship Mapping"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Scholarship</label>
                                            <select required value={reqData?.Scholarship} onChange={(e) => handleChange("scholarship", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="" selected>Select</option>
                                                {scholarship?.map((obj) => {
                                                    return (
                                                        <option value={obj?.id}>{obj?.provider_name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Entity</label>
                                            <select required value={reqData?.entity} onChange={(e) => handleChange("entity", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="" selected>Select</option>
                                                <option value={"college"}>Institute</option>
                                                <option value={"source_country"}>Source Country</option>
                                                <option value={"target_country"}>Target Country</option>
                                                <option value={"department"}>Department</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Entity Value</label>
                                            {/* <Select
                                                isMulti
                                                value={reqData?.entity_id}
                                                onChange={(selectedOptions) => handleChange("entity_id", selectedOptions)}
                                                options={entity.map(option => ({ value: option.id, label: option.name }))}
                                            /> */}
                                            <Select
                                                required
                                                isMulti
                                                value={reqData?.entity_id}
                                                onChange={(selectedOptions) => handleChange("entity_id", selectedOptions)}
                                                onInputChange={handleInputChange}
                                                options={entity.map(option => ({ value: option.id, label: option.name }))}
                                                isLoading={Boolean(loader == "entity")} // Optional: Show loading indicator while fetching data
                                                placeholder="Search..."
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={Boolean(loader == "submit")}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {Boolean(loader == "submit") ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddScholarshipMapping;